export * from './AuthenticationActionCreators';
export * from './AppActionCreators';
export * from './ConstantsActionCreators';
export * from './FolderActionCreators';
export * from './OCFolderActionCreators';
export * from './ContactActionCreators';
export * from './UserActionCreators';
export * from './SubscriptionsActionCreators';
export * from './translations';
export * from './CompanyActionCreators';
export * from './ChannelActionCreators';
export * from './BroadcastActionCreator';
export * from './InviteActionCreator';
export * from './DataPageActionCreators';
export * from './DataGatePageActionCreators';
export * from './SendReferralActionCreator';
export * from './DataSubscriptionActionCreators';
export * from './InvoiceActionCreators';
export * from './PollActionCreators';
export * from './ComposerActionCreators';
export * from './TradeActionCreators';
export * from './internal/StatsActionCreators';
export * from './referral';
export * from './context';
export * from './ChannelMailingListActionCreators';
export * from './DataInterestFormCreators';
// NOT IN USE
export * from './ImagePreviewActionCreators';

import { clearUser } from './UserActionCreators';
// TODO fix typo handleResponse
export const handleReponse = (res, dispatch) => {
  if (res.status === 200) return res.json();
  if (res.status === 401 && dispatch) {
    dispatch(clearUser());
    window.location.reload();
  }
  throw new Error(res.statusText);
};



// WEBPACK FOOTER //
// ./app/actions/index.js